import Icon from "@react-native-vector-icons/material-design-icons";
import { useNavigation } from "@react-navigation/native";
import { getOpaqueColor } from "helpers/shared.helpers";
import React, { useContext, useMemo, useState } from "react";
import { Pressable, StyleSheet, Text } from "react-native";
import { DASHBOARD_SCREENS } from "web/constants";
import { ConfirmationContext } from "webContext/Confirmation.context";
import { OrganizationContext } from "webContext/Organization.context";

const classes = StyleSheet.create({
  sideBarItemWrapper: {
    width: "100%",
    height: 65,
    padding: 5,
    position: "relative",
    flexDirection: "row",
    alignItems: "center",
    borderLeftWidth: 5,
    borderLeftColor: "transparent",
    transitionDuration: "150ms",
    transitionProperty: "background-color",
    gap: 15,
    paddingLeft: 20,
  },
});

export default function SideBarItem(props) {
  const { title, icon, route, onPress, selectedItem, setSelectedItem } = props;

  const { organizationColor } = useContext(OrganizationContext);
  const { showConfirmation } = useContext(ConfirmationContext);

  const [hovered, setHovered] = useState(false);
  const navigation = useNavigation();

  const stateClasses = useMemo(
    () =>
      StyleSheet.create({
        sideBarItemPressed: {
          backgroundColor: getOpaqueColor(organizationColor, 0.1),
          borderLeftWidth: 5,
          borderLeftColor: organizationColor,
        },
        sideBarItemHovered: {
          backgroundColor: getOpaqueColor(organizationColor),
        },
        icon: {
          color: organizationColor,
        },
        iconImage: {
          width: 25,
          height: 25,
          fill: organizationColor,
        },
        title: {
          fontSize: 20,
          textAlign: "left",
          color: organizationColor,
        },
      }),
    [organizationColor],
  );

  const { icon: ScreenIcon, title: screenTitle } =
    DASHBOARD_SCREENS[route] ?? {};

  const isSelected = selectedItem && selectedItem === route;

  const handleClick = () => {
    if (onPress) {
      onPress();
    } else {
      setSelectedItem(route);
    }

    if (route) {
      // Intercept navigation if on org settings and unsaved changes
      if (isOnOrgSettings && hasUnsavedChanges) {
        showConfirmation({
          prompt:
            "You have unsaved changes. Are you sure you want to leave this page?",
          onConfirm: () => {
            window.__orgSettingsUnsavedChanges = false;
            navigation.navigate(route);
          },
          onCancel: () => {},
        });
      } else {
        navigation.navigate(route);
      }
    }
  };

  const isOnOrgSettings = window.location.pathname.includes(
    "organization-settings",
  );
  const hasUnsavedChanges = window.__orgSettingsUnsavedChanges || false;

  return (
    <Pressable
      style={({ pressed }) => [
        classes.sideBarItemWrapper,
        (pressed || isSelected) && stateClasses.sideBarItemPressed,
        hovered && stateClasses.sideBarItemHovered,
      ]}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onPress={handleClick}
    >
      {ScreenIcon ? (
        <ScreenIcon style={stateClasses.iconImage} />
      ) : (
        <Icon style={stateClasses.icon} name={icon} size={30} />
      )}
      <Text style={stateClasses.title}>{screenTitle ?? title}</Text>
    </Pressable>
  );
}
